import { FC } from 'react';

import { Box } from '@mui/material';

import { splitHighlight } from '../model/highlight';

interface Props {
  text: string;
  query: string;
}

const HighlightedText: FC<Props> = ({ text, query }) => (
  <>
    {splitHighlight(text, query).map((segment, index) =>
      segment.match ? (
        <Box
          key={index}
          component="mark"
          sx={{
            backgroundColor: 'accentExtension.highlight',
            color: 'inherit',
            borderRadius: '0.1875rem',
            padding: 0,
          }}
        >
          {segment.text}
        </Box>
      ) : (
        <span key={index}>{segment.text}</span>
      ),
    )}
  </>
);

export default HighlightedText;
